import React from 'react';
import { Link as UiLink } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { UncontrolledTooltip } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { tooltipPreventOverflowModifiers } from '../misc/utils';

interface Props {
  htmlId?: string;
  className?: string;
  icon?: IconProp;
  text?: string;
  onClick?: () => void;
  visited?: boolean;
  noFit?: boolean;
  underline?: boolean;
  title?: string;
  width?: string;
  isLegacy?: boolean;
}

const LinkButton: React.FC<Props> = ({
  htmlId,
  className,
  icon,
  text = '',
  onClick,
  visited = false,
  noFit,
  underline,
  title,
  width = '',
  isLegacy,
}) => {
  const widthCustom = width !== '' ? width : 'w-100';
  // Botón de solo ícono: antes se renderizaba igual el span de texto vacío, con 5px de padding
  // por lado, todo a la DERECHA del ícono. El link quedaba más ancho que el ícono y el ícono
  // corrido del centro, que es donde reactstrap apunta la flecha de un tooltip/popover
  // asociado. Sin el span, `.linkbutton-icon-only` reparte esos mismos 10px a ambos lados del
  // ícono: mismo ancho total (no cambia la separación con lo de al lado) e ícono centrado.
  const iconOnly = !text && !isLegacy;
  const { t } = useTranslation();
  return (
    <div
      role="presentation"
      onClick={onClick}
      style={{ width: noFit ? widthCustom : 'fit-content' }}
    >
      <UiLink
        id={htmlId}
        className={classNames(className, { 'linkbutton-icon-only': iconOnly })}
        color="nothing"
        to="#"
        onClick={(e) => {
          e.preventDefault();
        }}
        title={title}
      >
        {icon && <FontAwesomeIcon icon={icon} className={visited ? 'visited' : ''} />}
        {!iconOnly &&
          (underline ? (
            <u>
              <span className="linkbutton-span">{text}</span>
            </u>
          ) : (
            <span className="linkbutton-span">
              {text}
              {isLegacy && (
                <>
                  <span className="ml-2 toolkit-tooltip" id="tr-toolkit-id-current">
                    <FontAwesomeIcon icon="exclamation-circle" className="lastUpdateInfo" />
                  </span>
                  <UncontrolledTooltip
                    className="tooltip-toolkit lastUpdateInfo"
                    placement="bottom"
                    target="tr-toolkit-id-current"
                    modifiers={tooltipPreventOverflowModifiers}
                  >
                    {t('sprMigratedMsg')}
                  </UncontrolledTooltip>
                </>
              )}
            </span>
          ))}
      </UiLink>
    </div>
  );
};

export default LinkButton;
